import React from 'react';
import { Card } from 'antd';

// Render a summary item using either a metric (circle) or pill style.
// When compact is true (e.g., on mobile), reduce paddings and font sizes.
const ItemCard = ({ item, compact = false }) => {
  const {
    label,
    value,
    prefix = '',
    suffix = '',
    format = 'raw',
    type = 'metric',
    color,
    bg,
  } = item || {};

  const isNumberLike = (v) => {
    if (v === null || v === undefined || v === '') return false;
    const n = Number(v);
    return Number.isFinite(n);
  };

  const formatValue = (v) => {
    if (!isNumberLike(v)) return `${prefix}${v}${suffix}`;
    const n = Number(v);
    try {
      if (format === 'comma') {
        return `${prefix}${new Intl.NumberFormat('en-US').format(n)}${suffix}`;
      }
      if (format === 'compact') {
        return `${prefix}${new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 }).format(n)}${suffix}`;
      }
    } catch (_) { /* fallback to raw */ }
    return `${prefix}${n}${suffix}`;
  };

  const valueText = formatValue(value);

  if (type === 'pill') {
    return (
      <Card
        size="small"
        style={{
          height: compact ? undefined : '100%',
          borderRadius: compact ? 2 : undefined,
        }}
        bodyStyle={{ padding: compact ? 0 : 10 }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: compact ? 1 : 8,
            padding: compact ? '0 1px' : '4px 10px',
            borderRadius: 999,
            background: bg || 'rgba(0,0,0,0.04)',
            color: color || '#333',
            fontSize: compact ? 6 : 12,
            fontWeight: 600,
            maxWidth: '100%',
            flexWrap: 'nowrap',
          }}
        >
          <span style={{ whiteSpace: 'nowrap' }}>{label}:</span>
          <span style={{ whiteSpace: 'nowrap' }}>{valueText}</span>
        </div>
      </Card>
    );
  }

  // default metric style
  return (
    <Card
      size="small"
      style={{
        height: compact ? undefined : '100%',
        borderRadius: compact ? 2 : undefined,
      }}
      bodyStyle={{ padding: compact ? 0 : 10 }}
    >
      <div style={{ display: 'flex', gap: compact ? 1 : 10, alignItems: 'center' }}>
        <div
          style={{
            minWidth: compact ? 10 : 36,
            height: compact ? 10 : 36,
            padding: compact ? '0 1px' : '0 8px',
            borderRadius: compact ? 5 : 18,
            background: bg || '#ffe58f',
            color: color || '#614700',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 700,
            fontSize: compact ? 10 : 12,
            flex: '0 0 auto',
            whiteSpace: 'nowrap',
          }}
        >
          {valueText}
        </div>
        <div style={{ fontSize: compact ? 10 : 12, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{label}</div>
      </div>
    </Card>
  );
};

export default ItemCard;